import { render, staticRenderFns } from "./RoomJoin.vue?vue&type=template&id=1f5f7df3&scoped=true&"
import script from "./RoomJoin.vue?vue&type=script&lang=js&"
export * from "./RoomJoin.vue?vue&type=script&lang=js&"
import style0 from "./RoomJoin.vue?vue&type=style&index=0&id=1f5f7df3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f7df3",
  null
  
)

export default component.exports